import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PhotoResult = lazyWithPreload(() => import('./PhotoResult'))
